<div class="wrapper text-align-center">
    <div class="content">
        <div class="indicate">
            <span class="text-primary">4</span><span class="text-accent">0</span><span class="text-primary">4</span>
        </div>
        <h3>Page Not Found</h3>
        <p class="error-message">The content you are looking for cannot be found.</p>
        <button mat-raised-button color="primary" routerLink="/home" class="btn-full">Home</button>
    </div>
</div>